export function convertLngLatToLatLng(lnglat) {
    return [lnglat.lat, lnglat.lng];
}
export function convertLatLngToLngLatLike(latlng) {
    return { lat: latlng[0], lng: latlng[1] };
}
export function convertLngLatBoundsToLatLngBounds(lnglatBounds) {
    const lats = [
        lnglatBounds.getNorthWest().lat,
        lnglatBounds.getSouthEast().lat,
    ];
    const lngs = [
        lnglatBounds.getNorthWest().lng,
        lnglatBounds.getSouthEast().lng,
    ];
    return [
        [Math.min(...lats), Math.min(...lngs)],
        [Math.max(...lats), Math.max(...lngs)],
    ];
}
export function convertLatLngBoundsToLngLatBoundsLike(latlngBounds) {
    return [
        convertLatLngToLngLatLike(latlngBounds[0]),
        convertLatLngToLngLatLike(latlngBounds[1]),
    ];
}
export function convertMaplibrePointToLibmapPoint(point) {
    return [point.x, point.y];
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiY29udmVydC5qcyIsInNvdXJjZVJvb3QiOiJzcmMvIiwic291cmNlcyI6WyJjb252ZXJ0LnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQVNBLE1BQU0sVUFBVSxxQkFBcUIsQ0FBQyxNQUFjO0lBQ25ELE9BQU8sQ0FBQyxNQUFNLENBQUMsR0FBRyxFQUFFLE1BQU0sQ0FBQyxHQUFHLENBQUMsQ0FBQTtBQUNoQyxDQUFDO0FBQ0QsTUFBTSxVQUFVLHlCQUF5QixDQUFDLE1BQWM7SUFDdkQsT0FBTyxFQUFFLEdBQUcsRUFBRSxNQUFNLENBQUMsQ0FBQyxDQUFDLEVBQUUsR0FBRyxFQUFFLE1BQU0sQ0FBQyxDQUFDLENBQUMsRUFBRSxDQUFBO0FBQzFDLENBQUM7QUFFRCxNQUFNLFVBQVUsaUNBQWlDLENBQ2hELFlBQTBCO0lBRTFCLE1BQU0sSUFBSSxHQUFHO1FBQ1osWUFBWSxDQUFDLFlBQVksRUFBRSxDQUFDLEdBQUc7UUFDL0IsWUFBWSxDQUFDLFlBQVksRUFBRSxDQUFDLEdBQUc7S0FDL0IsQ0FBQTtJQUNELE1BQU0sSUFBSSxHQUFHO1FBQ1osWUFBWSxDQUFDLFlBQVksRUFBRSxDQUFDLEdBQUc7UUFDL0IsWUFBWSxDQUFDLFlBQVksRUFBRSxDQUFDLEdBQUc7S0FDL0IsQ0FBQTtJQUNELE9BQU87UUFDTixDQUFDLElBQUksQ0FBQyxHQUFHLENBQUMsR0FBRyxJQUFJLENBQUMsRUFBRSxJQUFJLENBQUMsR0FBRyxDQUFDLEdBQUcsSUFBSSxDQUFDLENBQUM7UUFDdEMsQ0FBQyxJQUFJLENBQUMsR0FBRyxDQUFDLEdBQUcsSUFBSSxDQUFDLEVBQUUsSUFBSSxDQUFDLEdBQUcsQ0FBQyxHQUFHLElBQUksQ0FBQyxDQUFDO0tBQ3RDLENBQUE7QUFDRixDQUFDO0FBQ0QsTUFBTSxVQUFVLHFDQUFxQyxDQUNwRCxZQUEwQjtJQUUxQixPQUFPO1FBQ04seUJBQXlCLENBQUMsWUFBWSxDQUFDLENBQUMsQ0FBQyxDQUFDO1FBQzFDLHlCQUF5QixDQUFDLFlBQVksQ0FBQyxDQUFDLENBQUMsQ0FBQztLQUMxQyxDQUFBO0FBQ0YsQ0FBQztBQUVELE1BQU0sVUFBVSxpQ0FBaUMsQ0FBQyxLQUFvQjtJQUNyRSxPQUFPLENBQUMsS0FBSyxDQUFDLENBQUMsRUFBRSxLQUFLLENBQUMsQ0FBQyxDQUFDLENBQUE7QUFDMUIsQ0FBQyJ9